module.exports = __webpack_public_path__ + "static/media/preventivo_verde.5cb110ef.svg";